(function () {
  'use strict';

  var instances = new Map();
  var transtoreObserver = null;
  var NAV_HEIGHT_MOBILE = 58;
  var NAV_HEIGHT_DESKTOP = 64;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getHeaderHeight() {
    var header = document.querySelector('.section-header');
    if (header) {
      var measured = header.getBoundingClientRect().height;
      if (measured > 0) return measured;
    }

    var raw = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    var parsed = parseFloat(raw);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 72;
  }

  function getNavHeightFallback() {
    return window.matchMedia('(min-width: 750px)').matches ? NAV_HEIGHT_DESKTOP : NAV_HEIGHT_MOBILE;
  }

  function syncNavHeightVar(height) {
    var resolved = height || getNavHeightFallback();
    document.documentElement.style.setProperty('--lp-pdp-subnav-height', resolved + 'px');
    return resolved;
  }

  function isMobileView() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function getTranstoreFloatingSelectors() {
    return [
      '[class*="ts-switcher"][class*="floating"]',
      '.ts-switcher-individual--floating',
      '.ts-switcher-btn--floating'
    ];
  }

  function shouldHideMobileTranstoreSwitcher() {
    return isMobileView() && (
      document.documentElement.classList.contains('lp-pdp-subnav-pinned') ||
      document.documentElement.classList.contains('lp-pdp-subnav-active')
    );
  }

  function hideMobileTranstoreSwitcher() {
    if (!shouldHideMobileTranstoreSwitcher()) return;
    getTranstoreFloatingSelectors().forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (el.closest('[data-lp-transtore-cluster]')) return;
        if (el.dataset.lpPdpSubnavTsHidden === 'true') return;
        el.dataset.lpPdpSubnavTsHidden = 'true';
        el.dataset.lpPdpSubnavTsPrevDisplay = el.style.display || '';
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
        el.style.setProperty('pointer-events', 'none', 'important');
        el.style.setProperty('opacity', '0', 'important');
      });
    });
  }

  function restoreMobileTranstoreSwitcher() {
    document.querySelectorAll('[data-lp-pdp-subnav-ts-hidden="true"]').forEach(function (el) {
      el.style.display = el.dataset.lpPdpSubnavTsPrevDisplay || '';
      el.style.removeProperty('visibility');
      el.style.removeProperty('pointer-events');
      el.style.removeProperty('opacity');
      delete el.dataset.lpPdpSubnavTsHidden;
      delete el.dataset.lpPdpSubnavTsPrevDisplay;
    });
  }

  function watchTranstoreInjections() {
    if (transtoreObserver || !isMobileView()) return;
    transtoreObserver = new MutationObserver(function () {
      if (shouldHideMobileTranstoreSwitcher()) hideMobileTranstoreSwitcher();
    });
    transtoreObserver.observe(document.body, { childList: true, subtree: true });
  }

  function unwatchTranstoreInjections() {
    if (!transtoreObserver) return;
    transtoreObserver.disconnect();
    transtoreObserver = null;
  }

  function restoreMainHeader(siteHeader, stickyHeaderEl) {
    if (!siteHeader) return;
    restoreMobileTranstoreSwitcher();
    unwatchTranstoreInjections();
    siteHeader.classList.remove(
      'shopify-section-header-hidden',
      'lp-pdp-subnav-header-suppressed'
    );
    document.documentElement.classList.remove('lp-pdp-subnav-pinned');
    document.documentElement.setAttribute('data-header-status', 'visible');
    if (stickyHeaderEl) stickyHeaderEl.preventHide = false;
  }

  function suppressMainHeader(siteHeader, stickyHeaderEl) {
    if (!siteHeader) return;
    siteHeader.classList.add(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky',
      'lp-pdp-subnav-header-suppressed'
    );
    document.documentElement.classList.add('lp-pdp-subnav-pinned');
    document.documentElement.setAttribute('data-header-status', 'hidden');
    if (stickyHeaderEl) stickyHeaderEl.preventHide = true;

    var dropMenus = siteHeader.querySelectorAll('drop-menu');
    dropMenus.forEach(function (menu) {
      if (typeof menu.close === 'function') menu.close();
    });

    hideMobileTranstoreSwitcher();
    watchTranstoreInjections();
  }

  function destroyInstance(id) {
    var inst = instances.get(id);
    if (!inst) return;
    if (inst.restoreHeader) inst.restoreHeader();
    unwatchTranstoreInjections();
    if (inst.sectionObserver) inst.sectionObserver.disconnect();
    if (inst.onScroll) window.removeEventListener('scroll', inst.onScroll, { passive: true });
    if (inst.onResize) window.removeEventListener('resize', inst.onResize);
    instances.delete(id);
    if (!instances.size) {
      document.documentElement.classList.remove('lp-pdp-with-subnav');
    }
  }

  function boot(root) {
    if (!root || root.dataset.lpPdpSubnavReady === 'true') return;

    var sectionId = root.getAttribute('data-section-id') || '';
    destroyInstance(sectionId);

    var bar = root.querySelector('[data-lp-pdp-subnav-bar]');
    var placeholder = root.querySelector('[data-lp-pdp-subnav-placeholder]');
    var overviewEl = document.getElementById('lp-pdp-overview');
    var links = Array.prototype.slice.call(root.querySelectorAll('[data-lp-pdp-subnav-link]'));

    if (!bar || !placeholder || !overviewEl || !links.length) return;

    root.dataset.lpPdpSubnavReady = 'true';
    document.documentElement.classList.add('lp-pdp-with-subnav');

    var siteHeader = document.querySelector('.section-header');
    var stickyHeaderEl = document.querySelector('sticky-header');
    var faqEl = document.getElementById('lp-pdp-faq');
    var reviewsEl = document.getElementById('lp-pdp-reviews');
    var subnavEndEl = faqEl || reviewsEl;
    var isScrolling = false;
    var scrollTimeout = null;
    var activeId = '';

    var targets = links.map(function (link) {
      var id = link.getAttribute('data-target') || (link.getAttribute('href') || '').replace('#', '');
      var el = id ? document.getElementById(id) : null;
      return { id: id, link: link, el: el };
    }).filter(function (item) { return item.id && item.el; });

    function getNavHeight() {
      var measured = bar.offsetHeight;
      return measured > 0 ? measured : getNavHeightFallback();
    }

    function getScrollOffset() {
      var headerPart = root.classList.contains('is-pinned') ? 0 : getHeaderHeight();
      return headerPart + getNavHeight() + 8;
    }

    function isBeforeSubnavEnd() {
      if (!subnavEndEl) return true;
      var minBottom = root.classList.contains('is-pinned')
        ? getNavHeight()
        : getHeaderHeight() + getNavHeight();
      return subnavEndEl.getBoundingClientRect().bottom > minBottom;
    }

    function restoreHeader() {
      restoreMainHeader(siteHeader, stickyHeaderEl);
    }

    function isNavActive() {
      if (root.classList.contains('is-pinned')) return true;
      var rect = root.getBoundingClientRect();
      return rect.bottom > getHeaderHeight() && rect.top < window.innerHeight;
    }

    function updatePin() {
      var headerH = getHeaderHeight();
      var navH = getNavHeight();
      var rootRect = root.getBoundingClientRect();
      var shouldPin = rootRect.top <= headerH && isBeforeSubnavEnd();

      root.classList.toggle('is-pinned', shouldPin);
      bar.classList.toggle('is-pinned', shouldPin);

      if (shouldPin) {
        suppressMainHeader(siteHeader, stickyHeaderEl);
        bar.style.top = '0px';
        placeholder.style.height = navH + 'px';
        document.documentElement.classList.add('lp-pdp-subnav-active');
      } else {
        restoreHeader();
        bar.style.top = '';
        placeholder.style.height = '0px';
        document.documentElement.classList.remove('lp-pdp-subnav-active');
      }

      window.dispatchEvent(new CustomEvent('lp-pdp-subnav-change'));
    }

    function setActive(id) {
      if (!id || id === activeId) return;
      activeId = id;
      links.forEach(function (link) {
        var linkId = link.getAttribute('data-target') || (link.getAttribute('href') || '').replace('#', '');
        link.classList.toggle('is-active', linkId === id);
        if (linkId === id) {
          link.setAttribute('aria-current', 'true');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    }

    function scrollToTarget(id, updateHash) {
      var target = document.getElementById(id);
      if (!target) return;

      isScrolling = true;
      clearTimeout(scrollTimeout);

      var top = target.getBoundingClientRect().top + window.scrollY - getScrollOffset();
      window.scrollTo({
        top: Math.max(0, top),
        behavior: prefersReducedMotion() ? 'auto' : 'smooth'
      });

      setActive(id);

      if (updateHash) {
        var nextHash = '#' + id;
        if (window.location.hash !== nextHash) {
          history.replaceState(null, '', nextHash);
        }
      }

      scrollTimeout = window.setTimeout(function () {
        isScrolling = false;
        updatePin();
      }, prefersReducedMotion() ? 0 : 700);
    }

    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        var id = link.getAttribute('data-target') || (link.getAttribute('href') || '').replace('#', '');
        if (!id || !document.getElementById(id)) return;
        event.preventDefault();
        scrollToTarget(id, true);
      });
    });

    var visibleMap = new Map();

    function pickActiveFromObserver() {
      if (isScrolling || !targets.length || !isNavActive()) return;

      var best = null;
      var bestRatio = 0;

      targets.forEach(function (item) {
        var ratio = visibleMap.get(item.id) || 0;
        if (ratio > bestRatio) {
          bestRatio = ratio;
          best = item;
        }
      });

      if (best && bestRatio > 0) {
        setActive(best.id);
        return;
      }

      var offset = getScrollOffset();
      var scrollY = window.scrollY + offset + 1;
      var current = targets[0];

      for (var i = 0; i < targets.length; i++) {
        var rect = targets[i].el.getBoundingClientRect();
        var top = rect.top + window.scrollY;
        if (top <= scrollY) current = targets[i];
      }

      setActive(current.id);
    }

    function createSectionObserver() {
      return new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          visibleMap.set(entry.target.id, entry.intersectionRatio);
        });
        pickActiveFromObserver();
      }, {
        root: null,
        threshold: [0, 0.15, 0.35, 0.55, 0.75, 1],
        rootMargin: '-' + getScrollOffset() + 'px 0px -55% 0px'
      });
    }

    var sectionObserver = createSectionObserver();

    targets.forEach(function (item) {
      sectionObserver.observe(item.el);
    });

    function onScroll() {
      updatePin();
      if (root.classList.contains('is-pinned')) {
        requestAnimationFrame(function () {
          if (root.classList.contains('is-pinned')) {
            suppressMainHeader(siteHeader, stickyHeaderEl);
          }
        });
      }
      if (!isScrolling) pickActiveFromObserver();
    }

    function onResize() {
      syncNavHeightVar(getNavHeight());
      sectionObserver.disconnect();
      sectionObserver = createSectionObserver();
      targets.forEach(function (item) {
        sectionObserver.observe(item.el);
      });
      updatePin();
      pickActiveFromObserver();
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);

    syncNavHeightVar(getNavHeight());
    updatePin();

    if (targets.length) {
      setActive(targets[0].id);
    }

    instances.set(sectionId, {
      root: root,
      bar: bar,
      sectionObserver: sectionObserver,
      onScroll: onScroll,
      onResize: onResize,
      restoreHeader: restoreHeader
    });

    root._lpPdpSubnavRebuild = function () {
      destroyInstance(sectionId);
      root.dataset.lpPdpSubnavReady = 'false';
      boot(root);
    };
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-lp-pdp-subnav]').forEach(boot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    var el = event.target && event.target.querySelector('[data-lp-pdp-subnav]');
    if (!el && event.target && event.target.matches('[data-lp-pdp-subnav]')) el = event.target;
    if (el) {
      el.dataset.lpPdpSubnavReady = 'false';
      boot(el);
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var el = event.target && event.target.querySelector('[data-lp-pdp-subnav]');
    if (!el && event.target && event.target.matches('[data-lp-pdp-subnav]')) el = event.target;
    if (el) {
      destroyInstance(el.getAttribute('data-section-id') || '');
      el.dataset.lpPdpSubnavReady = 'false';
    }
  });
})();
